import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Helmet } from "react-helmet";
import './SignDisclosure.css';
import FundingProgressBarComponent from '../common/FundingProgressBarComponent';
import HelloSignEmbeddedComponent from '../common/HelloSignEmbeddedComponent';
import SignDisclosureDoneComponent from './SignDisclosureDoneComponent';
import signDisclosureOperations from './duck/operations'

// const _ = require('lodash');
class SignDisclosureContainer extends Component {

	constructor(props) {
		super(props);
		this.state = {
			state: ''
			, submissionUuid: ''
			, contactUuid: ''
			, signingStatus: ''
			, urlStatus: ''
			, contactSigningStatus: {}
		};
	}

	async componentDidMount() {
		console.log('FULL MATCH PARAMS:', this.props.match.params);

		let state = this.props.match.params.state;
		let submissionUuid = this.props.match.params.submissionUuid;
		let contactUuid = this.props.match.params.contactUuid;

		console.log('componentDidMount state = ', state);
		console.log('componentDidMount submissionUuid = ', submissionUuid);
		console.log('componentDidMount contactUuid = ', contactUuid);

		const contactSigningStatus = await this.props.prepareDisclosure(
			state,
			submissionUuid,
			contactUuid
		);

		this.setState({
			state,
			submissionUuid,
			contactUuid,
			contactSigningStatus
		});
	}

	render() {
		const { contactSigningStatus } = this.state;

		// Contract has already been signed
		if (contactSigningStatus?.status === 'Signed') {
			return (
				<>
					<Helmet>
						<title>Uplyft Capital Funding | Contract Signed</title>
					</Helmet>

					<div id='helloSign' className="layoutFading space">
						<FundingProgressBarComponent
							dots={[
								// { name: "Contract Review", status: 1 },
								{ name: "Sign Contract", status: 1 }
							]}
						/>

						<div className='container pt-2 space'>
							<div className="shadow p-5 mb-2 bg-white roundCorners text-center">
								<h2>You Already Signed the Disclosure</h2>
							</div>
						</div>
					</div>
				</>
			);
		} else  if (this.state.contactSigningStatus.signURL) {
			let clientId = process.env.REACT_APP_SIGN_CONTRACT_CLIENT_ID_LEGACY;
			return (
				<>
					<Helmet>
						<title>Uplyft Capital Funding | Sign-Disclosure</title>
					</Helmet>
					<div id='helloSign' className="layoutFading space">
						<FundingProgressBarComponent dots={[{ name: "Sign Contract", status: 1 }]} />
						<div className='container pt-2 space'>
							{this.props.eventListener ?
								<div id="signContractDone">
									<SignDisclosureDoneComponent submissionUuid={this.state.submissionUuid} handleSignContractError={this.props.handleSignContractError} />
								</div>
								:
								<div className='shadow p-5 mb-2 bg-white roundCorners'>
									<div id="signContract">
										<HelloSignEmbeddedComponent
											// clientId='3c781ac6f277a9789cd0dc6da95c31db'
											clientId={clientId}
											signatureId={this.state.contactSigningStatus.signatureId}
											url={this.state.contactSigningStatus.signURL.url}
											onSigningEvent={this.props.onSigningEvent}
											signingEventParams={{ submissionUuid: this.state.submissionUuid, contactUuid: this.state.contactUuid }}
											uxVersion={2}
											inContainer={true}
										/>
									</div>
								</div>
							}
						</div>
					</div>
				</>
			);
		} else {
			return (
				<div className='spinner'>
					<div className='loader'>Loading...</div>
				</div>
			);
		}
	}
}

SignDisclosureContainer.propTypes = {
	offer: PropTypes.object
};

const mapStateToProps = state => ({
	contactsSigningStatus: state.signContract.contactsSigningStatus,
	contactSigningStatus: state.signContract.contactSigningStatus,
	eventListener: state.signContract.contactSigningStatus.eventListener,
	signingStatus: state.signContract.contactSigningStatus.status,
	urlStatus: state.signContract.contactSigningStatus.signURL ? state.signContract.contactSigningStatus.signURL.status : '',
});

const mapDispatchToProps = dispatch => {
    const prepareDisclosure = (state, submissionUuid, contactUuid) =>
        dispatch(
            signDisclosureOperations.prepareDisclosure(
                state,
                submissionUuid,
                contactUuid
            )
        );

    const handleSignContractError = () =>
        dispatch(signDisclosureOperations.handleSignContractError());

    const onSigningEvent = (params) =>
        dispatch(signDisclosureOperations.onSigningEvent(params));

    return {
        prepareDisclosure,
        onSigningEvent,
        handleSignContractError
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignDisclosureContainer);